export type StaticCurrency = {
  code: string
  name: string
  symbol: string
  isDefault?: boolean
}

/** Mirrors api/bin/database/seed.js — used for guest invoice UI without API calls. */
export const STATIC_CURRENCIES: StaticCurrency[] = [
  { code: 'ARS', name: 'Argentine Peso', symbol: '$' },
  { code: 'AUD', name: 'Australian Dollar', symbol: '$' },
  { code: 'BTC', name: 'Bitcoin', symbol: '฿' },
  { code: 'BRL', name: 'Brazilian Real', symbol: 'R$' },
  { code: 'CAD', name: 'Canadian Dollar', symbol: '$' },
  { code: 'EUR', name: 'Euro', symbol: '€' },
  { code: 'GBP', name: 'British Pound Sterling', symbol: '£' },
  { code: 'INR', name: 'Indian Rupee', symbol: '₹' },
  { code: 'NZD', name: 'New Zealand Dollar', symbol: '$' },
  { code: 'USDT', name: 'Thether', symbol: '₮' },
  { code: 'USD', name: 'US Dollar', symbol: '$', isDefault: true },
  { code: 'ZAR', name: 'South African Rand', symbol: 'R' },
]

export const DEFAULT_CURRENCY_CODE =
  STATIC_CURRENCIES.find((c) => c.isDefault)?.code ?? 'USD'

export function getStaticCurrencyByCode(code: string): StaticCurrency | undefined {
  return STATIC_CURRENCIES.find((c) => c.code === code)
}
